// src/components/auth/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSalon } from "../../context/SalonContext";
import NoSalonSelected from "../salon/NoSalonSelected";

export default function ProtectedRoute({ children, requireSalon = false }) {
    const { accessToken, salonUuid } = useSalon();
    const location = useLocation();

    // Not logged in → redirect to login with intended path
    if (!accessToken) {
        return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
    }

    // If route also requires a salonUuid
    if (requireSalon && !salonUuid) {
        return <NoSalonSelected />;
    }

    return children;
}
